export default [

	{

		html: `
		<p>In New York, a city of eight million people, only 1.5% of census tracts saw two or more gun homicide incidents in 2015. That’s a much lower percentage than St Louis, where a shocking 44% of census tracts saw multiple gun homicides in 2015. </p>

	<p>Compared with St Louis, New York also has much broader swathes of the city that saw no gun homicides at all.</p>

	<p>New York City’s murder rate of about four murders per 100,000 people is neatly in line with the national average. </p>
		`
	},
	{

		html: `
			<p>Gun homicides spiked in Baltimore in 2015, leaving the city with its highest-ever recorded murder rate. But the increased homicides remained concentrated, with largely white neighborhoods almost completely exempt from the rising violence. 92% of Baltimore’s gun murder victims in 2015 were black men, according to local police department statistics.
</p>
		`
	},

	{

		html: `
		<p>In 2015, Chicago had the highest total number of gun homicides of any city in America. But the city's gun homicide rate per person was much lower than St Louis. </p>

<p>Just 13% of census tracts in Chicago saw multiple gun murders in 2015, and these tracts were responsible for 65% of the city’s gun homicides. </p>
		`
	},

	{

		html: `
		<p>The most concentrated gun homicide areas in Oakland cluster far from the city center, in the long stretch of East Oakland known as the flatlands. </p>

<p>Though Chicago’s population is nearly seven times larger than Oakland’s, the two cities showed similar levels of gun homicide concentration. In both cities, nearly 70% of all census tracts saw no gun homicides, and the 13% of census tracts that saw multiple gun homicides were responsible for the majority of the city’s fatal gun violence. </p>
		`
	},

	{

		html: `
			<p>22% of New Orleans census tracts saw multiple gun homicides, and these areas were responsible for more than 75% of the murders. The concentration of violence in New Orleans is closest to the concentration in Baltimore.

</p>
		`
	}
];
